export default __webpack_public_path__ + "static/tabet-6a2a7c779c799c18f0c8dbc00a6a64f9.webp";